import { render, staticRenderFns } from "./popupInput.vue?vue&type=template&id=70779422&scoped=true"
import script from "./popupInput.vue?vue&type=script&lang=js"
export * from "./popupInput.vue?vue&type=script&lang=js"
import style0 from "./popupInput.vue?vue&type=style&index=0&id=70779422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70779422",
  null
  
)

export default component.exports